/* eslint-disable no-new */
import { $Q, $Qll } from "../utils/query-selector";

/**
 * initialize top bar announce
 */
export const initTopBar = () => {
  const topBar = $Q('.top__bar');

  if (!topBar) return;

  const slides = $Qll('.top__bar--message');

  if (slides.length < 2) return;

  topBar.style.width = `${topBar.getBoundingClientRect().width}px`
};
